import { html } from 'lit';
import componentStyles from './screenreader-text.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class ScreenreaderText extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      text: { type: String },
    };
  }

  render() {
    return html`<span>${this.text}</span>`;
  }
}
customElements.define('hf-screenreader-text', ScreenreaderText);
